const initialState = {
    partnerUsers: [],
    partnerUser: null,
    isLoading: false,
    isError: false,
    errorMessage: '',
    partnerUserUpdated: null,
    partnerUserCreated: null,
}

export default function partnerReducer(state = initialState, action: any) {
    switch (action.type) {
        case 'GET_ALL_PARTNER_USERS':
            return { ...state, partnerUsers: action.payload, errorMessage: '', isError: false, isLoading: false };
        case 'GET_PARTNER_USER':
            return { ...state, partnerUser: action.payload, errorMessage: '', isError: false, isLoading: false };
        case 'UPDATE_PARTNER_USER':
            return { ...state, partnerUserUpdated: action.payload, errorMessage: '', isError: false, isLoading: false };
        case 'CREATE_PARTNER_USER':
            return { ...state, partnerUserCreated: action.payload, errorMessage: '', isError: false, isLoading: false };
        case 'PARTNER_ACTION_STARTS':
            return { 
                ...state, 
                isLoading: true,
                partnerUserCreated: null,
                partnerUserUpdated: null,
                isError: false,
                errorMessage: ''
            };
        case 'PARTNER_ACTION_ERRORS':
            return { ...state, isError: true, errorMessage: action.payload, isLoading: false };
        case 'RESET_PARTNER_ERRORS':
            return { 
                ...state, 
                isError: false, 
                errorMessage: '',
            };
        default:
            return state;
    }
}